import { render, staticRenderFns } from "./StickerPayBasket.vue?vue&type=template&id=4df05c55&scoped=true&"
import script from "./StickerPayBasket.vue?vue&type=script&lang=ts&"
export * from "./StickerPayBasket.vue?vue&type=script&lang=ts&"
import style0 from "./StickerPayBasket.vue?vue&type=style&index=0&id=4df05c55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df05c55",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCard,VIcon,VProgressCircular})
